import { useEffect } from 'react';

function useGetScript({ src, async = true, type = 'text/javascript' }) {
	useEffect(() => {
		const scriptTag = document.createElement('script');
		scriptTag.src = src;
		scriptTag.type = type;
		scriptTag.async = async;
		document.body.appendChild(scriptTag);

		return () => {
			scriptTag.remove();
		};
	}, [src, async, type]);
}

export default useGetScript;
